import React, { useEffect, useState } from "react";
import { Button, Table, message, Space, Input } from "antd";
import axios from "axios";
import { getConfig } from "../../../../../config";
import { JobCode } from "../../../../../types/JobCodes";
import { UndoOutlined } from "@ant-design/icons";

const { API_BASE_URL } = getConfig();

interface ProductApprovalProps {
    selectedProject: string;
    jobCodes: JobCode[];
    setJobCodes: (data: JobCode[]) => void;
}

const ProductApproval: React.FC<ProductApprovalProps> = ({ selectedProject, jobCodes, setJobCodes }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleReset = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get<JobCode[]>(
                `${API_BASE_URL}/getNetworkPlanJobCodes?auth=VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU&projectNo=${selectedProject}`
            );
            setJobCodes(response.data);
        } catch (error) {
            message.error("Fehler beim Laden der Daten.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDescriptionChange = (alias: string, newValue: string) => {
        const updatedJobCodes = jobCodes.map((job) =>
            job.alias === alias ? { ...job, descriptionSpez: newValue } : job
        );
        setJobCodes(updatedJobCodes);
    };

    const columns = [
        { title: "Alias", dataIndex: "alias", key: "alias", width: 150 },
        { title: "All. Bezeichnung", dataIndex: "description", key: "description", width: 150 },
        {
            title: "Spez. Bezeichnung",
            dataIndex: "descriptionSpez",
            key: "descriptionSpez",
            width: 300,
            render: (text: string, record: JobCode) =>
                <Input
                    value={text}
                    onChange={(e) => handleDescriptionChange(record.alias, e.target.value)}
                />
        },
    ];

    return (
        <div style={{ padding: "20px" }}>
            <Space style={{ marginBottom: 16, display: "flex", justifyContent: "flex-end" }}>
                <Button
                    icon={<UndoOutlined />}
                    type="primary"
                    onClick={handleReset}
                    loading={isLoading}
                >
                    Daten neu laden
                </Button>
            </Space>
            <Table
                columns={columns}
                dataSource={jobCodes}
                rowKey="alias"
                pagination={{ pageSize: 100 }}
                loading={isLoading}
            />
        </div>
    );
};

export default ProductApproval;
